import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useReportContext } from '../../../context/DetailContext';

type TabItem = {
  name: string;
  onclick: () => void;
};

const NavigationTab = () => {
  const [currentTab, setCurrentTab] = useState<string>('요약정보');
  const [isFixed, setIsFixed] = useState<boolean>(false);
  const [isFull, setIsFull] = useState<boolean>(false);
  const [visibleTabs, setVisibleTabs] = useState<TabItem[]>([]);
  const { type } = useReportContext();

  const navRef = useRef<HTMLDivElement | null>(null);
  const originalTopRef = useRef<number | null>(null);

  const handleScroll = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 120;
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
    }
  };

  const TabButtons: TabItem[] = [
    // {
    //   name: '요약정보',
    //   onclick: () => {
    //     setCurrentTab('요약정보');
    //     handleScroll('요약정보');
    //   },
    // },
    {
      name: '물건기본정보',
      onclick: () => {
        setCurrentTab('물건기본정보');
        handleScroll('물건기본정보');
      },
    },
    {
      name: '기일현황',
      onclick: () => {
        setCurrentTab('기일현황');
        handleScroll('기일현황');
      },
    },
    {
      name: '물건현황',
      onclick: () => {
        setCurrentTab('물건현황');
        handleScroll('물건현황');
      },
    },
    {
      name: '임차인현황',
      onclick: () => {
        setCurrentTab('임차인현황');
        handleScroll('임차인현황');
      },
    },
    {
      name: '등기부현황',
      onclick: () => {
        setCurrentTab('등기부현황');
        handleScroll('등기부현황');
      },
    },
    {
      name: '감정가',
      onclick: () => {
        setCurrentTab('감정가');
        handleScroll('감정가');
      },
    },
    {
      name: '권리분석',
      onclick: () => {
        setCurrentTab('권리분석');
        handleScroll('권리분석');
      },
    },
    {
      name: '예상배당표',
      onclick: () => {
        setCurrentTab('예상배당표');
        handleScroll('예상배당표');
      },
    },
    {
      name: '경매집행비용',
      onclick: () => {
        setCurrentTab('경매집행비용');
        handleScroll('경매집행비용');
      },
    },

    {
      name: '가격분석',
      onclick: () => {
        setCurrentTab('가격분석');
        handleScroll('가격분석');
      },
    },
    {
      name: '매각통계',
      onclick: () => {
        setCurrentTab('매각통계');
        handleScroll('매각통계');
      },
    },
    {
      name: '관할법원',
      onclick: () => {
        setCurrentTab('관할법원');
        handleScroll('관할법원');
      },
    },
    {
      name: '첨부파일',
      onclick: () => {
        setCurrentTab('첨부파일');
        handleScroll('첨부파일');
      },
    },
  ];

  const PAuctionTabButtons: TabItem[] = [
    {
      name: '물건기본정보',
      onclick: () => {
        setCurrentTab('물건기본정보');
        handleScroll('물건기본정보');
      },
    },
    {
      name: '입찰이력',
      onclick: () => {
        setCurrentTab('입찰이력');
        handleScroll('입찰이력');
      },
    },
    {
      name: '입찰정보',
      onclick: () => {
        setCurrentTab('입찰정보');
        handleScroll('입찰정보');
      },
    },
    {
      name: '입찰방법및입찰제한정보',
      onclick: () => {
        setCurrentTab('입찰방법및입찰제한정보');
        handleScroll('입찰방법및입찰제한정보');
      },
    },
    {
      name: '낙찰후인도/인수책임',
      onclick: () => {
        setCurrentTab('낙찰후인도/인수책임');
        handleScroll('낙찰후인도/인수책임');
      },
    },
    {
      name: '물건현황',
      onclick: () => {
        setCurrentTab('물건현황');
        handleScroll('물건현황');
      },
    },
    {
      name: '임차인현황',
      onclick: () => {
        setCurrentTab('임차인현황');
        handleScroll('임차인현황');
      },
    },
    {
      name: '등기부현황',
      onclick: () => {
        setCurrentTab('등기부현황');
        handleScroll('등기부현황');
      },
    },
    {
      name: '감정가',
      onclick: () => {
        setCurrentTab('감정가');
        handleScroll('감정가');
      },
    },

    {
      name: '가격분석',
      onclick: () => {
        setCurrentTab('가격분석');
        handleScroll('가격분석');
      },
    },
  ];

  useEffect(() => {
    const baseTabs = type === 'a' ? TabButtons : PAuctionTabButtons;

    const timeout = setTimeout(() => {
      const filteredTabs = baseTabs.filter((tab) => {
        const el = document.getElementById(tab.name);
        return el;
      });
      setVisibleTabs(filteredTabs);
    }, 300); // 충분한 렌더 딜레이

    return () => clearTimeout(timeout);
  }, [type]);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsFull(window.innerWidth > 900);
    const handleResize = () => setIsFull(window.innerWidth > 900);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const tabRefs = useRef<(HTMLDivElement | null)[]>([]);
  const tabScrollRef = useRef<HTMLDivElement>(null);

  const scrollTabIntoCenter = () => {
    const index = visibleTabs.findIndex((item) => item.name === currentTab);
    const tabEl = tabRefs.current[index];
    const scrollContainer = tabScrollRef.current;

    if (tabEl && scrollContainer) {
      const scrollOffset =
        tabEl.offsetLeft -
        scrollContainer.clientWidth / 2 +
        tabEl.clientWidth / 2;

      scrollContainer.scrollTo({ left: scrollOffset, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    scrollTabIntoCenter();
  }, [currentTab]);

  useEffect(() => {
    const handleScroll = () => {
      if (!navRef.current) return;

      const scrollY = window.scrollY;
      const { top } = navRef.current.getBoundingClientRect();
      if (originalTopRef.current === null) originalTopRef.current = top;
      setIsFixed(scrollY > originalTopRef.current);

      for (let i = 0; i < visibleTabs.length; i++) {
        const element = document.getElementById(visibleTabs[i].name);
        if (element && element.getBoundingClientRect().bottom > 200) {
          const navEl = document.getElementById(visibleTabs[i].name + '_nav');
          if (navEl) {
            navRef.current.scrollTo({
              left: navEl.offsetLeft - 10,
              behavior: 'smooth',
            });
          }
          setCurrentTab(visibleTabs[i].name);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [visibleTabs]);

  return (
    <Container ref={navRef} isFixed={isFixed}>
      <Inner ref={tabScrollRef}>
        {visibleTabs.map((tab, idx) => (
          <TabButton
            key={idx}
            onClick={tab.onclick}
            ref={(el) => {
              tabRefs.current[idx] = el;
            }}
            active={currentTab === tab.name}
            id={tab.name + '_nav'}
          >
            {tab.name}
          </TabButton>
        ))}
      </Inner>
    </Container>
  );
};

export default NavigationTab;

interface ContainerProps {
  isFull?: boolean;
  isFixed: boolean;
}

const Container = styled.div<ContainerProps>`
  position: ${(props) => (props.isFixed ? 'fixed' : 'relative')};
  top: ${(props) => (props.isFixed ? '54px' : 'auto')};
  width: ${(props) => (props.isFull ? '900px' : '100%')};
  overflow-x: auto;
  background-color: #fff;

  /* 스크롤바 숨기기 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE, Edge */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
    height: 8px;
  }
  z-index: 100;
`;
const Inner = styled.div`
  padding: 0 8px;
  display: flex;
  flex-direction: row;
  overflow-x: scroll;
  border-bottom: 1px solid #e5e8ea;
`;
const TabButton = styled.div<{ active: boolean }>`
  padding: 13px 9px;
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
  border-bottom: ${({ active }) => active && ' 2px solid #222'};

  color: ${(props) => (props.active ? '#222222' : '#989BA2')};
  cursor: pointer;
  /* background-color: ${(props) =>
    props.active ? '#222222' : 'rgba(112, 115, 124, 0.08)'}; */
`;
